module.exports = __webpack_public_path__ + "static/media/caravelle.e3680e2e.jpg";